import { DOCUMENT, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

/**
 * Guard que sai da SPA e carrega uma URL estática (ex.: um PDF em `/assets`).
 * Cancela a navegação do router e troca a página via `location.href`, como o
 * `ContratoComponent` do site antigo.
 */
export function redirectToAsset(url: string): CanActivateFn {
  return () => {
    inject(DOCUMENT).location.href = url;
    return false;
  };
}
